import { icons, variants, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import newExcel from "../../../assets/images/newExcel.svg";
import pdf from "../../../assets/images/pdf.svg";
/** Ids de los items del dropdown "Exportar" (ver onExportReport en el hook). */
export var EXPORT_OPTION_ID = {
    excel: "1",
    pdf: "2",
};
export var REPORT_FILTERS = [
    {
        label: "Limpiar Filtros",
        type: "cleanButton",
        variantButtons: variants.text,
        visible: true,
    },
    {
        disabled: false,
        label: "Exportar",
        listButtonDropdown: [
            {
                icons: icons.DownloadForOffline,
                id: EXPORT_OPTION_ID.excel,
                img: newExcel,
                name: "Descargar Excel",
            },
            {
                icons: icons.DownloadForOffline,
                id: EXPORT_OPTION_ID.pdf,
                img: pdf,
                name: "Descargar PDF",
            },
        ],
        showImage: true,
        type: "exportButton",
        variantButtons: variants.text,
        visible: true,
    },
    {
        id: "dateRange",
        label: "Rango de fechas",
        type: "dateRange",
    },
];
export var INITIAL_PAGE = 1;
export var INITIAL_PAGE_SIZE = 5000;
